import { useState } from "react";
import styles from "./faq.module.css";
import { QuestionBubbleIcon, ChevronDownIcon, ChevronRightIcon } from "@/assets/svg";

type FAQItem = {
  question: string;
  answer: string;
};

const faqItems: FAQItem[] = [
  {
    question: "Why is there an annual fee for protesting?",
    answer:
      "Property taxes are reassessed annually, and each year presents new opportunities to challenge your assessment. The annual fee covers ongoing monitoring, analysis, and the ability to file protests each tax year to ensure you're always paying fair property taxes.",
  },
  {
    question: "Do i have to protest every year?",
    answer:
      "While you don't have to protest every year, property values and assessments change annually. We recommend reviewing your assessment each year to ensure you're not overpaying. Our service makes it easy to protest whenever needed.",
  },
  {
    question: "What if they there is no value change ?",
    answer:
      "If there's no change in your property value assessment, you may not need to protest that year. However, we continue to monitor your property and the surrounding area to identify any future opportunities for savings.",
  },
  {
    question: "Can my protest tax go up every year ?",
    answer:
      "While property tax rates can increase, our goal is to help ensure your assessed value is fair and accurate. By protesting when appropriate, we work to prevent over-assessment and keep your tax burden as low as legally possible.",
  },
];

/**
 * FAQ Component
 * Displays frequently asked questions with expandable answers
 */
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className={styles.faqSection}>
      <div className={styles.faqContent}>
        <h2 className={styles.mainTitle}>
          FAQ<span className={styles.titleHighlight}>&apos;S</span>
        </h2>

        <div className={styles.faqLayout}>
          {/* Left Section - Introduction */}
          <div className={styles.introSection}>
            <div className={styles.iconWrapper}>
              <QuestionBubbleIcon className={styles.questionIcon} />
            </div>
            <h3 className={styles.introHeading}>
              Get answers to some{" "}
              <span className={styles.introHighlight}>Frequently Asked Questions</span>
            </h3>
            <p className={styles.introSubtext}>
              Have a riddle that needs a human to crack? We got you.
            </p>
            <a href="#contact" className={styles.supportLink}>
              Speak to our customer support now <ChevronRightIcon className={styles.chevronRight} />
            </a>
          </div>

          {/* Right Section - FAQ List */}
          <div className={styles.faqListSection}>
            <div className={styles.faqCard}>
              {faqItems.map((item, index) => (
                <div
                  key={index}
                  className={`${styles.faqItem} ${openIndex === index ? styles.faqItemOpen : ""}`}
                >
                  <button
                    className={styles.faqQuestion}
                    onClick={() => toggleFAQ(index)}
                    aria-expanded={openIndex === index}
                  >
                    <span className={styles.questionText}>{item.question}</span>
                    <ChevronDownIcon
                      className={`${styles.chevronIcon} ${openIndex === index ? styles.chevronRotated : ""}`}
                    />
                  </button>
                  {openIndex === index && (
                    <div className={styles.faqAnswer}>
                      <p>{item.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.decorativeShapes} aria-hidden="true">
        <div className={styles.shape1}></div>
        <div className={styles.shape2}></div>
        <div className={styles.shape3}></div>
      </div>
    </section>
  );
};
